/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import ActionDropdown from 'components/Antd/ActionDropdown';
import classes from './Table.module.scss';

const ColumnActions = ({ className = '', dropdownOverlay = '', color = '', ...other }) => {
  return (
    <ActionDropdown
      placement="bottomRight"
      trigger={['click']}
      {...other}
      className={cn(classes.columnActions, className)}
      overlayClassName={cn(classes.dropdownOverlay, classes[color], dropdownOverlay)}
    />
  );
};

export default ColumnActions;
